import { useIntl } from "react-intl";

import { uploadFile } from "api";

export type UploadResult = {
  id: number;
  reference_number: string;
  name: string;
  url: string;
  [key: string]: any;
};

export function useFileUpload() {
  const intl = useIntl();

  const maxFileSizeMsg = intl.formatMessage({
    id: "request-form.provider.uploadFreightDocuments.maxFileSize",
    defaultMessage: "(max filesize 15mb)",
  });

  function upload(file: File, onProgress: (percent: number) => void, signal?: AbortSignal): Promise<UploadResult> {
    if (file.size >= 15_000_000) {
      return Promise.reject(new Error(maxFileSizeMsg));
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("filename", file.name);

    return uploadFile(formData, {
      onUploadProgress: (e: any) => onProgress(Math.round((e.loaded * 100) / e.total)),
      signal,
    }).then((res: any) => res.data);
  }

  return { upload };
}
